// Capture lightweight page + UTM context to attach to a new session.
// No PII — just what would already sit in a typical analytics beacon.

const ANON_KEY = 'voyage-chat-anon';

export function readAnonId(): string {
  try {
    const existing = localStorage.getItem(ANON_KEY);
    if (existing && existing.length >= 8) return existing;
    const fresh = crypto.randomUUID();
    localStorage.setItem(ANON_KEY, fresh);
    return fresh;
  } catch {
    return '';
  }
}

export function pageContext() {
  const url = new URL(location.href);
  const q = url.searchParams;
  return {
    pageUrl: location.href,
    pageTitle: document.title,
    referrer: document.referrer || undefined,
    utmSource: q.get('utm_source') ?? undefined,
    utmMedium: q.get('utm_medium') ?? undefined,
    utmCampaign: q.get('utm_campaign') ?? undefined,
    utmTerm: q.get('utm_term') ?? undefined,
    utmContent: q.get('utm_content') ?? undefined,
    anonId: readAnonId() || undefined
  };
}
